define(["require", "exports", "knockout"], function (require, exports, ko) {
    "use strict";
    var EmployeeRoleModel = /** @class */ (function () {
        function EmployeeRoleModel(data) {
            this.Id = ko.observable(0);
            this.Name = ko.observable();
            this.IsSystem = ko.observable();
            this.SystemKey = ko.observable();
            var self = this;
            if (data) {
                ko.mapping.fromJS(data, EmployeeRoleModel.Mapping, self);
            }
        }
        EmployeeRoleModel.Mapping = {
            key: function (data) {
                return data.Id;
            },
            create: function (options) {
                return new EmployeeRoleModel(options.data);
            }
        };
        return EmployeeRoleModel;
    }());
    return EmployeeRoleModel;
});
//# sourceMappingURL=EmployeeRoleModel.js.map


//////////////////
// WEBPACK FOOTER
// ./build/models/EmployeeRoleModel.js
// module id = 297
// module chunks = 2